import { observer } from "mobx-react-lite";
import { Button, Header, Label, Segment, Icon } from "semantic-ui-react";

import { Form, Formik, Field, useFormik } from "formik";
import Swal from "sweetalert2";
import * as Yup from "yup";
import ReactToPrint from "react-to-print";
import React, { useEffect, useState, useRef } from "react";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import MyTextInput, { MyTextInputConvD, MyTextInputConv, MyTextAreatConv, MyTextInputFechas } from "../../../app/common/form/MyTextInput";

import { InstitucionesPublicasNumero } from "../../../app/common/options/InstitucionesPublicasConvenio";
import { RegionalBannerCentral } from "../../Portafolio/Handlers/RegionalBannerCentral";
import { MySelectInputControl } from "../../../app/common/form/MySelectInput";
import { myBreadCrumbsConvRaiz, myBreadCrumbsConvInte } from '../Handlers/BreadCrumbsConv';
import UploadFileModal from '../Handlers/uploadFilesModal';

import { calculoFechas } from "../../Portafolio/helpers/calculoFechas";
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import Modal from 'react-bootstrap/Modal';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import "../src/css/convenios.css";

let convFiles: any = [];
let soliID: any;

let fnombresolic: string,
    nombreResponsable: string,
    fcorreorespo: string,
    ftelrespo: string,
    fenti: any,
    fdescripcion: string;

interface solicitud {
    id: number,
    nombreSolicitante: string,
    nombreResponsable: string,
    correoResponsable: string,
    telefonoResponsable: number,
    sgtEntidad: any,
    descripcion: string,
    files: any,
    createdAt: any
}

export default observer(function ModalSolicitudMod(

    SOL: {
        key: number;
        show: any,
        onHide: any,
        soldes: string,
        solid: number,
        ctype: string,
        nsolic: string,
        nrespo: string,
        crespo: string,
        trespo: number,
        entsol: string,
        datsol: string,
    }) {

    const [loading, setLoading] = useState(false);
    const [modalShow, setModalShow] = React.useState(false);
    const [modalShowF, setModalShowF] = React.useState(false);

    const apiURL = process.env.REACT_APP_API_URL + `/CATSolicitudConvenios`;


    function catchval() {
        fnombresolic = (document.getElementById("nombreSolicitante") as HTMLInputElement).value;
        nombreResponsable = (document.getElementById("nombreSolicitante") as HTMLInputElement).value;
        fcorreorespo = (document.getElementById("nombreSolicitante") as HTMLInputElement).value;
        ftelrespo = (document.getElementById("nombreSolicitante") as HTMLInputElement).value;
        fenti = (document.getElementById("nombreSolicitante") as HTMLInputElement).value;
        fdescripcion = (document.getElementById("nombreSolicitante") as HTMLInputElement).value;
    }

    // useEffect(() => {

    //     catchval();

    //   }, [ ]);

    const SOLApi = process.env.REACT_APP_API_URL + `/Storage/${SOL.solid}/${SOL.ctype}`;
    const filePathURL = process.env.REACT_APP_FILEPATH_SOL_URL;
    const getDetallesConv = async () => {
        setLoading(true);
        const r = await fetch(SOLApi);
        const data = await r.json();
        convFiles = data;

        setLoading(false);
    }; useEffect(() => { getDetallesConv() }, []);

    const initialsol: solicitud = {
        id: SOL.solid,
        nombreSolicitante: SOL.nsolic,
        nombreResponsable: SOL.nrespo,
        correoResponsable: SOL.crespo,
        telefonoResponsable: SOL.trespo,
        descripcion: SOL.soldes,
        sgtEntidad: SOL.entsol,
        files: null,
        createdAt: SOL.datsol
    };

    const getSubmitHandler = (saving: any) => async (values: any, formik: any) => {
        const endpoint = saving ? apiURL : apiURL;
        const jsonData = JSON.stringify(values);

        return fetch(endpoint, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: jsonData,
        })
            .then(function (response) {
                if (response.ok) {
                    ExitVal();
                } else {
                    throw new Error("Hubo un error");
                }
            })
    };

    function ExitVal() {
        Swal.fire({
            position: "center",
            showCloseButton: true,
            title: 'Solicitud actualizada exitosamente',
            text: "Tu solicitud ha sido actualizada con exito y los datos ya pueden ser utilizados para crear un nuevo código institucional.",
            icon: 'success',

            showConfirmButton: true,
            confirmButtonText: 'Aceptar',
            confirmButtonAriaLabel: "confirm-button",

        }).then((result) => {
            if (result.isConfirmed) {

                // window.location.href = `/cargapagos/crear-convenio`;
                // window.location.href = `/reportes/solicitudes-institucionales`;
                window.location.reload();
            } else if (result.isDismissed) {
                // setModalShow(false);
            }
        })
    };

    return (

        <>

            <Modal
                {...SOL}
                size="lg"
                className="modal-add-dep-content modal-solicitud-mod"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton >
                    <Modal.Title id="contained-modal-title-vcenter">
                        Modificación de la solicitud No. {SOL.solid}
                    </Modal.Title>
                </Modal.Header>

                {loading ? (
                    <LoadingComponent content="Cargando contenido del código..." />
                ) : (

                    <Modal.Body>
                        <Container className="modal-sol-detalle">
                            <Row className="soli-form-modal-area">

                                <Formik
                                    onSubmit={(values, { setSubmitting, resetForm, validateForm }) => {
                                        getSubmitHandler(values);
                                        setSubmitting(false);
                                        validateForm(true);
                                        resetForm();
                                    }}
                                    initialValues={initialsol}
                                // validationSchema={validationSchema}
                                >
                                    {(formik) => (
                                        <>

                                            <Container className="detalle_convenio-area solicitudes-conv-form-area">

                                                <Row className="convenio-form-area solicitudes-conv-form solicitud-mod-form">

                                                    {/* <div className="form-header">
                                                        <h3>
                                                            Llena el siguiente formulario para solicitar un convenio.
                                                        </h3>
                                                    </div> */}

                                                    <Form className="convenio-form ui form">
                                                        <Row>

                                                            <MySelectInputControl
                                                                label="Entidad del código"
                                                                id="sgtEntidad"
                                                                name="sgtEntidad"
                                                                placeholder={"- Selecciona una opción -"}
                                                                options={InstitucionesPublicasNumero}
                                                            />

                                                            <Row>
                                                                <Col sm={6} className="col-mod-conv">
                                                                    <MyTextInputConv
                                                                        label="Ingresa el nombre del solicitante del código:"
                                                                        type="input"
                                                                        name="nombreSolicitante"
                                                                        id="nombreSolicitante"
                                                                        placeholder={"Solicitante"}
                                                                        defaultValue={SOL.nsolic}
                                                                    />
                                                                </Col>
                                                                <Col sm={6} className="col-mod-conv">
                                                                    <MyTextInputConv
                                                                        name="nombreResponsable"
                                                                        label="Ingresa el nombre de la persona responsable:"
                                                                        type="input"
                                                                        id="nombreResponsable"
                                                                        defaultValue={SOL.nrespo}
                                                                        placeholder={"Ej: Nombres y Apellidos"}
                                                                    />
                                                                </Col>
                                                            </Row>

                                                            <Row>
                                                                <Col sm={6} className="col-mod-conv">
                                                                    <MyTextInputConv
                                                                        name="correoResponsable"
                                                                        label="Correo del responsable:"
                                                                        type="input"
                                                                        id="correoResponsable"
                                                                        defaultValue={SOL.crespo}
                                                                        placeholder={"Ej: Dirección de Recursos humanos"}
                                                                    />
                                                                </Col>

                                                                <Col sm={6} className="col-mod-conv">
                                                                    <MyTextInputConv
                                                                        name="telefonoResponsable"
                                                                        label="Teléfono del responsable:"
                                                                        type="input"
                                                                        id="telefonoResponsable"
                                                                        defaultValue={SOL.trespo}
                                                                        placeholder={"Ej: 0000 0000"}
                                                                    />
                                                                </Col>

                                                            </Row>

                                                            <MyTextAreatConv
                                                                name="descripcion"
                                                                label="Descripcion de la solicitud"
                                                                placeholder="Menesaje: "
                                                                type="input"
                                                                id="descripcion"
                                                                defaultValue={SOL.soldes}
                                                            />

                                                        </Row>

                                                        <Button
                                                            disabled={!(formik.isValid && formik.dirty)}
                                                            variant="primary"
                                                            onClick={() => { getSubmitHandler({ saving: true })(formik.values, formik.isValid) }}
                                                        >
                                                            Guardar
                                                        </Button>

                                                    </Form>
                                                </Row>
                                            </Container>
                                        </>
                                    )}
                                </Formik>
                                    <Row className="files-list-area">

                                        <Container className="convenios-documentos-area">
                                            <div className="form-header">
                                                <h2>Documentos de la solicitud</h2>
                                                <hr />
                                                {/* <h3 className="info-message-convenio">
                                                    A continuación encuentra los archivos o documentos que
                                                    respaldan los procesos del convenio.
                                                </h3> */}
                                            </div>

                                            <Row className="files-list-area">
                                                <Container className="file-list-header">
                                                    <Col xs={2}>Fecha:</Col>
                                                    <Col xs={8}>Descripcion:</Col>
                                                    <Col xs={2}>Acciones:</Col>
                                                </Container>
                                            </Row>

                                            {convFiles &&
                                                convFiles.map((docu: any) => (
                                                    <Container key={docu?.id} className="archivo-item">
                                                        <Col xs={2}>{calculoFechas(docu.createdAt)}</Col>
                                                        <Col xs={8}>{docu.descriptionFile}</Col>
                                                        <Col xs={2}>
                                                            <a
                                                                href={filePathURL + "/" + docu?.fileName}
                                                                target="blank"
                                                            >
                                                                <Button.Group basic size="small">
                                                                    <Button icon="download" />
                                                                </Button.Group>
                                                            </a>
                                                        </Col>
                                                    </Container>
                                                ))}
                                        </Container>

                                    </Row>


                            </Row>

                            <Row className="upload-files-button-area">
                                <Button
                                    className="primary upload-files"
                                    type="button"
                                    animated
                                    onClick={() => setModalShowF(true)}
                                >
                                    <Button.Content visible>
                                        Cargar archivos
                                    </Button.Content>
                                    <Button.Content hidden>
                                        <Icon name="file pdf outline" />
                                    </Button.Content>
                                </Button>
                            </Row>


                        </Container>

                    </Modal.Body>

                )}

            </Modal>

            <UploadFileModal
                onHide={() => { setModalShowF(false) }}
                show={modalShowF}
                solicitudID={SOL.solid}
                CType={"CATSolicitudConvenio"}
                insti={null}
            />

        </>

    );

})